import React, { useEffect, useState } from "react";
import axios from "../axios";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import LoaderImg from '../img/logo/running.gif';
import Login from "../logo/loginsuccess.gif";
import redirectImg from '../img/other/redirect.gif';
import { ToastContainer } from 'react-toastify';
import { toast } from "react-toastify";

const PaymentConfirmPopup = (props) => {

  const navigate = useNavigate();
  const { state } = useLocation();
  const EditEventId = state ? state.eventId : 0;
  const [UserDetails, setUserDetails] = useState([]);
  const [TicketBookingFlag, setTicketBookingFlag] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [PaymentGateway, setPaymentGateway] = useState(1);
  const [PaymentUrl, setPaymentUrl] = useState("");
  const [ButtonDisplayFlag, setButtonDisplayFlag] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  // console.log(props.PayRedirectionUrl);
  let NewEventId = 0;
  let FinalAmount = 0;

  let PaymentGatewayFlag = 0;
  let PaymentReturnUrl = "";

  if(props.BookTicktesArray){
    NewEventId  = props.BookTicktesArray.event_id; 
    FinalAmount = props.BookTicktesArray.TotalPrice;

    PaymentGatewayFlag = props.PaymentGatewayFlag;
    PaymentReturnUrl   = props.PaymentReturnUrl;
  }
  // console.log(props.PaymentGatewayFlag, props.PaymentReturnUrl, PaymentGatewayFlag);
   const handleClick = () => {
    setIsDisabled(true); // disable button
    window.location.href = PaymentUrl; // PaymentReturnUrl;
  };

  // console.log(props.EventId, props.FinalAmount, props.RoundoffAmount, JSON.stringify(props.BookTicktesArray));
  useEffect(() => {
    setLoader(true);
    const formData = new FormData();

    for (let i = 0; i < props.NewFilesArray.length; i++) {
      formData.append("fils_array[]", props.NewFilesArray[i]);
    }

    formData.append('event_id', props.EventId ? props.EventId : NewEventId);
    formData.append('amount', props.FinalAmount ? props.FinalAmount : FinalAmount);
    formData.append('extra_round_off_amount', props.RoundoffAmount ? props.RoundoffAmount : 0);
    formData.append('ticket_type', 'paid');
    formData.append('booking_tickets_array', JSON.stringify(props.BookTicktesArray));
    // formData.append('files_array', props.NewFilesArray);

    axios.post("bookingPaymentProcess", formData)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          const UserDetails = response.data.data;
          // console.log(UserDetails.payment_gateway);
          setUserDetails(UserDetails);
          setPaymentGateway(UserDetails ? UserDetails.payment_gateway : 1);
          setPaymentUrl(UserDetails ? UserDetails.payment_url : "");
          
          localStorage.setItem("booking_pay_id", response.data.data.booking_pay_id);
          setButtonDisplayFlag('is-visible');
          localStorage.setItem('redirect_url_flag',1);
          setLoader(false);
        }else{
          setButtonDisplayFlag('');
          toast.error("Something went wrong");
          const timer = setTimeout(() => {
              navigate('/register_now/'+localStorage.getItem('RegEventId'));
            }, 6000); // Adjust the delay as needed (in milliseconds)
          return () => clearTimeout(timer);
          setLoader(false);
        }
       
      })
      .catch(() => {
        console.log('error');
        setLoader(false);
        //props.setOpenTree(false);
      });

  }, [props.EventId]);
  // console.log(UserDetails, PaymentGatewayFlag);

  //----------- book ticket entry
  const bookingPayId = localStorage.getItem('booking_pay_id');

  let success_url = '';
  let failure_url = '';
  let payment_gateway_url = '';

  let url_flag = 2;  // prime - 1 / live - 2 / local - 3 

  let isPassiloStaging = window.location.pathname.includes("passilo_staging");
  if(isPassiloStaging){
    url_flag = 1; // Staging server
  }

  if (url_flag === 1) {
    success_url = 'https://swtprime.com/passilo_backend/Transcation/Payment_process.php';
    failure_url = 'https://swtprime.com/passilo_backend/Transcation/Payment_process.php';
    payment_gateway_url = 'https://test.payu.in/_payment';
  } else if (url_flag === 2) {
    success_url = 'https://races.swtgrid.com/Transcation/Payment_process.php';
    failure_url = 'https://races.swtgrid.com/Transcation/Payment_process.php';
    payment_gateway_url = 'https://secure.payu.in/_payment';
  } else {
    success_url = 'http://localhost/swt_marathon_backend/Transcation/Payment_process.php';
    failure_url = 'http://localhost/swt_marathon_backend/Transcation/Payment_process.php';
    payment_gateway_url = 'https://test.payu.in/_payment';
  }

  useEffect(() => {
    const handleContextmenu = e => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu)
    }
  }, [])

  useEffect(() => {
    const handleKeyDown = (event) => {
      event.preventDefault();
      //console.log("Key press is disabled.");
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}

      <div className={"modal " + ButtonDisplayFlag} data-animation="slideInUp">
        <div className="modal-dialog quickview__main--wrapper">
           <p style={{cursor:'pointer', float:'right'}}
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel your payment? Click OK to exit, or Cancel to stay.")) {
                props.setPaymentConfirmPopupflag(false);
                props.setIsDisabled(false);
              }
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 -960 960 960" width="28" fill="#e86363">
                    <path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                </svg> 
            </p>
          <div className="quickview__inner">
             
            <div className="row">
              <div className="login__section">
                <div className="login__section--inner">
                
                      <div className="p-5">
                        <div className="account__login--header mb-25 text-center">

                          <img src={redirectImg} alt="" style={{ height: 250 }} />
                          <p className='h3 mb-3'>Redirect to payment</p>
                          <p className="account__login--header__desc">You are being redirected to payment gateway site</p>
                        </div>
                        <div className="text-center">
                          {/* <form action="https://pay1.getepay.in:8443/getePaymentPages/doPayment?token=86566596-92e7-48c0-92d4-2399623500cf" method='post'>*/}
                          
                          {(PaymentGateway == 1) ?
                         
                            <form action={props.PayRedirectionUrl ? props.PayRedirectionUrl : 'https://test.payu.in/_payment'} method='post'> 
                              <input type="hidden" name="key" value={UserDetails.merchant_key} />
                              <input type="hidden" name="txnid" value={UserDetails.txnid} />
                              <input type="hidden" name="productinfo" value={UserDetails.productinfo} />
                              <input type="hidden" name="amount" value={UserDetails.amount} />
                              <input type="hidden" name="email" value={UserDetails.email} />
                              <input type="hidden" name="firstname" value={UserDetails.firstname} />
                              <input type="hidden" name="surl" value={success_url} />
                              <input type="hidden" name="furl" value={failure_url} />
                              <input type="hidden" name="hash" value={UserDetails.hash} /> 

                              <input type="submit" name="command" value="Pay Now" className="account__login--btn success__btn mt-2" onClick={(e) => { setTicketBookingFlag(true); }} />
                            </form> 
                          :
                            <button
                                className="account__login--btn success__btn mt-2"
                                onClick={handleClick}
                                disabled={isDisabled}
                            >
                                {isDisabled ? (
                                  <span className="processing">
                                    Processing<span className="dots"></span>
                                  </span>
                                ) : (
                                  "Pay Now"
                                )}
                            </button>
                          } 
                        </div>
                      </div>
                     
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default PaymentConfirmPopup;
